import "@/App.css";
import PublicBlog from "@/pages/PublicBlog";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProfimySuite from "@/components/ProfimySuite";
import AuthPage from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import CommandCenter from "@/pages/CommandCenter";
import { Scout, Market, Competitor } from "@/pages/Discover";
import { ListingAI, PhotoAI, Price, Optimizer, Reposter } from "@/pages/Selling";
import { Messenger, Negotiator, AntiScam } from "@/pages/Conversations";
import { Orders, Stock, Crossposter } from "@/pages/Operations";
import { Profitability, Dashboard, CEO } from "@/pages/Performance";
import { DailyPlan, MorningBrief, Watchdog, Alerts, Memory, Learning, Autopilot } from "@/pages/AgentPages";
import { Connectors, Queue, Audit, Settings, Admin } from "@/pages/System";
import { Paywall, PaymentSuccess } from "@/pages/Growth";
import Landing from "@/pages/Landing";
import Order, { SetPasswordPage } from "@/pages/Order";
import Affiliate from "@/pages/Affiliate";
import Tutorial from "@/pages/Tutorial";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-[#7CFF00] mono text-sm pulse-dot" data-testid="app-loading">LBC AGENT · chargement…</div>;
  if (!user) return <Navigate to="/offre" replace />;
  if (user.role !== "admin" && ["PENDING", "EXPIRED", "SUSPENDED"].includes(user.entitlement?.status)) return <Paywall />;
  if (!user.workspace?.onboarding_done && loc.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return children;
}

const PAGES = { tutoriel: Tutorial, scout: Scout, market: Market, competitor: Competitor, listing: ListingAI, photo: PhotoAI, price: Price, optimizer: Optimizer,
  reposter: Reposter, messenger: Messenger, negotiator: Negotiator, "anti-scam": AntiScam, orders: Orders, stock: Stock, crossposter: Crossposter,
  profitability: Profitability, dashboard: Dashboard, ceo: CEO, "daily-plan": DailyPlan, "morning-brief": MorningBrief, watchdog: Watchdog,
  alerts: Alerts, memory: Memory, learning: Learning, autopilot: Autopilot, connectors: Connectors, queue: Queue, audit: Audit, settings: Settings, admin: Admin, parrainage: Affiliate };

export default function App() {
  if (/^\/blog(?:\/|$)/.test(window.location.pathname)) return <PublicBlog />;
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/outils" element={<Navigate to="/outils/lbc-agent" replace />} />
            <Route path="/outils/:tool" element={<ProfimySuite current="lbc-agent" home="/" />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/offre" element={<Landing />} />
            <Route path="/commande" element={<Order />} />
            <Route path="/set-password" element={<SetPasswordPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Home />} />
              <Route path="command" element={<CommandCenter />} />
              {Object.entries(PAGES).map(([p, C]) => <Route key={p} path={p} element={<C />} />)}
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
